import type { School, Unit } from '@/domain/units';
import { api } from '@/utils/configuration';
import { crudService } from '@/utils/request';
import type { GenericAbortSignal } from 'axios';

export const UnitService = {
  search: async ([communityId]: [number], signal?: GenericAbortSignal) =>
    await crudService.get<Unit[]>(`${api.COMMUNITIES}/${communityId}/units`, {
      signal,
    }),

  getById: async ([communityId, id]: [number, number], signal?: GenericAbortSignal) =>
    await crudService.get<Unit>(`${api.COMMUNITIES}/${communityId}/units/${id}`, {
      signal,
    }),

  getNearbySchools: async ([communityId, id]: [number, number], signal?: GenericAbortSignal) =>
    await crudService.get<School[]>(
      `${api.COMMUNITIES}/${communityId}/units/${id}/nearby-schools`,
      {
        signal,
      },
    ),
};
